var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.3399C6.47715 22.3399 2 17.8627 2 12.3399C2 6.81705 6.47715 2.3399 12 2.3399C17.5228 2.3399 22 6.81705 22 12.3399C22 17.8627 17.5228 22.3399 12 22.3399ZM12 20.3399C16.4183 20.3399 20 16.7582 20 12.3399C20 7.92162 16.4183 4.3399 12 4.3399C7.58172 4.3399 4 7.92162 4 12.3399C4 16.7582 7.58172 20.3399 12 20.3399ZM11 15.3399H13V17.3399H11V15.3399ZM13 13.695V14.3399H11V12.8399C11 12.2876 11.4477 11.8399 12 11.8399C12.8284 11.8399 13.5 11.1683 13.5 10.3399C13.5 9.51147 12.8284 8.8399 12 8.8399C11.2723 8.8399 10.6656 9.35813 10.5288 10.0457L8.56731 9.65337C8.88637 8.0491 10.302 6.8399 12 6.8399C13.933 6.8399 15.5 8.4069 15.5 10.3399C15.5 11.9254 14.4457 13.2647 13 13.695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListQuestion);
export default __webpack_public_path__ + "static/media/list-question.e833c2bc4359ce7700ef293ab59e22de.svg";
export { ForwardRef as ReactComponent };